export default "__VITE_PUBLIC_ASSET__14d733f6__"